module.exports = __webpack_public_path__ + "components/flag/static/square/af-343359b4166226a013b57a0865d05fbc.svg";